<ng-container *ngIf="solverResultsAndConditonsAndRangeVariable && solverResultsAndConditonsAndRangeVariable[0]">
  <app-result-table-buttons [resultTable]="this"></app-result-table-buttons>

  <div class="view full-border">
    <div class="wrapper">
      <table [class]="defaultStyle?' default bordered':''" *ngIf="results && results.length > 0">
        <tr [class]="defaultStyle?'bordered':''" *ngFor="let key of keys">
          <ng-container *ngIf="resultMeta[key] && resultMeta[key].isHeading">
            <td [class]="'headerKey sticky-col first-col'" (click)="select(key)">
              {{(selectedHeaders[key]?'- ':'+ ') + key}}</td>
            <ng-container *ngIf="key=='System'">
              <td *ngFor="let result of results,let index=index"
                [class]="result['Calculation Failed'].value ?'bordered error':'bordered'">
                {{'#'+(isRangedResult? (index+1) : results.length-index) + (result["Calculation Failed"].value ? " Error" : "")}}
              </td>
            </ng-container>
            <ng-container *ngIf="key!='System'">
              <td *ngFor="let result of results,let index=index" [class]="'bordered'">
                {{' '}}
              </td>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="visibleKeys[key] && ['Calculation Failed','Calculation Message'].indexOf(key) == -1">
            <ng-container *ngIf="(resultMeta[key] && !resultMeta[key].isHeading)">
              <td
                [class]="rangedVariableKeys[key] ? 'bordered rangedVariable sticky-col first-col' : selectedKeys[key] ? 'bordered selectedKey sticky-col first-col' : defaultStyle?'key bordered sticky-col first-col':'sticky-col first-col'"
                (click)="toggleValueSelection(key)">
                {{key + " " + (resultMeta[key].quantity != undefined ? "("+unitsService.getSelectedUnitForQuantity(resultMeta[key].quantity)+")":"")}}
              </td>
              <td *ngFor="let result of results"
                [class]="rangedVariableKeys[key] ? 'bordered rangedVariable' : selectedKeys[key] ? 'bordered selected' : result[key] && result[key].input ? defaultStyle? 'input-value bordered' : '' : defaultStyle? 'value bordered' : 'value-italic'">
                {{result[key]?(result[key].value?formattingService.isNumber(result[key].value)?formattingService.formatNumber(result[key].quantity?unitsService.convertFromSIForQuantity(result[key].quantity,result[key].value):result[key].value):result[key].value:""):""}}
              </td>
            </ng-container>
          </ng-container>
        </tr>
      </table>
    </div>
  </div>

  <div *ngIf="isRangedResult" style="padding-top: 10px;">
    <table>
      <ng-container *ngFor="let result of results; let index=index">
        <tr *ngIf="result['Calculation Failed'].value">
          <td class="error">{{'#'+(index+1)+' Error '}}</td>
          <td>{{result["Calculation Message"].value}}</td>
        </tr>
      </ng-container>
    </table>
  </div>

</ng-container>
